import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import styles from 'components/Pages/Admin/styles.module.css';
import FIDCAlert from 'components/Shared/FIDCAlert';
import PageLoader from 'components/Shared/PageLoader';
import { formatUrlWithUtm } from 'helpers/functions';
import { useAuthReady } from 'hooks/useAuthReady';
import { BLINKET_TICKETS_APP_URL } from 'settings';

const AttendanceList = React.lazy(() => import('components/Pages/Admin/AttendanceList'));
const EventType = React.lazy(() => import('components/Pages/Admin/Event/EventType'));
const EventEdit = React.lazy(() => import('components/Pages/Admin/EventEdit'));
const EditByCntCod = React.lazy(() => import('components/Pages/Admin/EventEdit/EditByCntCod'));
const HelpCenterIndexPage = React.lazy(() => import('components/Pages/Admin/HelpCenter'));
const Home = React.lazy(() => import('components/Pages/Admin/Home'));
const MyEvents = React.lazy(() => import('components/Pages/Admin/MyEvents'));
const TabsMyEvents = React.lazy(() => import('components/Pages/Admin/TabsMyEvents'));
const EventCreate = React.lazy(() => import('Pages/Events/Create'));
const DuplicateEvent = React.lazy(() => import('Pages/Events/Duplicate'));
const EditEvent = React.lazy(() => import('Pages/Events/Edit'));
const Detail = React.lazy(() => import('Pages/Participants/Detail'));

const AuthenticatedRoutes = () => {
  const { isReady, isLoading, isProducer } = useAuthReady();

  if (isLoading || !isReady) {
    return <PageLoader />;
  }

  // Rotas restritas a produtores. Não-produtores são redirecionados para /home.
  const producerOnly = (Component: React.ComponentType<any>) => (props: any) =>
    isProducer ? <Component {...props} /> : <Redirect to='/home' />;

  return (
    <div className={styles.content}>
      <FIDCAlert />
      <Switch>
        <Redirect exact from='/' to='/home' />

        <React.Suspense fallback={<PageLoader />}>
          <Route exact path='/home' component={Home} />
          <Route exact path='/help-center' component={HelpCenterIndexPage} />

          <Route exact path='/event' component={EventType} />
          <Route exact path='/event/create/:type' component={EventCreate} />

          <Route exact path='/event/edit/:id' component={EditEvent} />
          <Route exact path='/event-duplicate/:id' component={DuplicateEvent} />
          <Route exact path='/event/edit_by_cnt_cod/:cntCod' component={EditByCntCod} />

          <Route exact path='/my-events' render={producerOnly(MyEvents)} />
          <Route exact path='/my-events/:id/edit' render={producerOnly(EventEdit)} />

          <Route exact path='/my-events/:id/:page' render={producerOnly(TabsMyEvents)} />

          <Route exact path='/my-events/:id/:page/:subPage' render={producerOnly(TabsMyEvents)} />

          <Route
            exact
            path='/my-tickets'
            component={() => {
              const url = formatUrlWithUtm(BLINKET_TICKETS_APP_URL, 'blinket', 'produtor');
              window.location.href = url;
              return <Redirect to={url} />;
            }}
          />

          <Route exact path='/presence-list/:eventId' component={AttendanceList} />
          <Route exact path='/presence-list/:eventId/participant/:cliCod' component={Detail} />
        </React.Suspense>

        <Route exact path='*' component={Home} />
      </Switch>
    </div>
  );
};

export default AuthenticatedRoutes;
